import { render, staticRenderFns } from "./Datepicker.global.vue?vue&type=template&id=f5836592&scoped=true&lang=pug&"
import script from "./Datepicker.global.vue?vue&type=script&lang=ts&"
export * from "./Datepicker.global.vue?vue&type=script&lang=ts&"
import style0 from "./Datepicker.global.vue?vue&type=style&index=0&id=f5836592&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5836592",
  null
  
)

export default component.exports